/**
 * Client-safe site constants.
 *
 * `next.config.js` requires Node-only modules (the email-components plugin pulls in
 * `fs`), so application code must never import it — doing so drags those requires
 * into the client bundle and the build fails with "Can't resolve 'fs'".
 * Values needed by both the Next config and app code live here instead.
 */
module.exports = {
  basePath: "",
};
